/** Default number of customer reviews shown on restaurant home. */
export const HOME_REVIEWS_PREVIEW_LIMIT = 4;

/** Page size when loading reviews on the dedicated reviews page. */
export const REVIEWS_PAGE_SIZE = 20;
